import { useState } from 'react'
import { products, type Product } from '@/constants/products'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { ProductsHeroSection } from './components/ProductsHeroSection'
import { ProductSystemTabs } from './components/ProductSystemTabs'
import { ProductVisionHero } from './components/ProductVisionHero'
import { ProductBentoGrid } from './components/ProductBentoGrid'
import { ProductEngineRoom } from './components/ProductEngineRoom'
import { ProductsDirectoryGrid } from './components/ProductsDirectoryGrid'
import { CustomSystemCtaSection } from './components/CustomSystemCtaSection'

export function ProductsFeature() {
  const [selectedProductId, setSelectedProductId] = useState<string>('suke')

  const activeProduct: Product =
    products.find((p) => p.id === selectedProductId) ?? products[0]!

  return (
    <div className="bg-surface-0 min-h-screen">
      {/* 1. Page Header & Systems Intro */}
      <ProductsHeroSection />

      {/* 2. Systems Showcase Spotlight */}
      <Section surface="0" className="pt-0 pb-12 sm:pb-16 md:pb-24">
        <Container>
          {/* Accessible horizontal tab list */}
          <ProductSystemTabs
            products={products}
            selectedProductId={selectedProductId}
            onSelectProduct={setSelectedProductId}
          />

          {/* Spotlight Presentation Block */}
          <div id="spotlight" className="scroll-mt-24">
            <ProductVisionHero product={activeProduct} />
            <ProductBentoGrid product={activeProduct} />
            <ProductEngineRoom product={activeProduct} />
          </div>

          {/* 3. Products Directory Grid */}
          <ProductsDirectoryGrid
            products={products}
            selectedProductId={selectedProductId}
            onSelectProduct={setSelectedProductId}
          />
        </Container>
      </Section>

      {/* 4. Consultation Proposal CTA Banner */}
      <CustomSystemCtaSection />
    </div>
  )
}
